import iconCollapseStyles from '../../../public/assets/css/swipe-icon-collapse.css?inline';

export const createIconCollapseStyle = (): void => {
  const styleElement = document.createElement('style');
  styleElement.appendChild(document.createTextNode(iconCollapseStyles));
  document.head.appendChild(styleElement);
};
